<template>
	<div class="sliders__block__child slider">
		<!-- Slider main container -->
		<div class="swiper-container">
			<!-- Additional required wrapper -->
			<div class="swiper-wrapper">
				<div
					class="swiper-slide"
					v-for="(slide, index) in JSON.parse(slides)"
					:key="index"
				>
					<h2 class="title" v-if="slide.title" v-html="slide.title"></h2>
					<h2 class="text" v-if="slide.text" v-html="slide.text"></h2>
					<primary-button
						class="the_button"
						v-if="slide.link"
						:link="slide.link"
						:label="'Read More'"
					></primary-button>
				</div>
			</div>

			<div class="swiper-pag-nag">
				<div class="swiper-nav">
					<div class="swiper-button-prev-testimonial">
						<img :src="prev_icon" alt="play" />
					</div>
					<div class="swiper-button-next-testimonial">
						<img :src="next_icon" alt="play" />
					</div>
				</div>
			</div>

			<!-- If we need scrollbar -->
			<!-- <div class="swiper-scrollbar"></div> -->
		</div>
	</div>
</template>

<script>
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.css';
Swiper.use([Navigation, Pagination, Autoplay]);
import PrimaryButton from '../vue/PrimaryButton.vue';

export default {
	data() {
		return {
			smallSlider: null,
		};
	},

	props: {
		slides: {},
		title: {},
		play_icon: {},
		next_icon: {},
		prev_icon: {},
	},

	computed: {},

	watch: {},

	methods: {
		initSlider() {
			this.smallSlider = new Swiper('.swiper-container', {
				// Optional parameters
				direction: 'horizontal',
				loop: true,
				autoHeight: true,
				autoplay: false,
				observer: true,
				observeParents: true,

				// Navigation arrows
				navigation: {
					nextEl: '.swiper-button-next-testimonial',
					prevEl: '.swiper-button-prev-testimonial',
				},
			});
		},
	},

	components: {
		PrimaryButton,
	},

	created() {},
	mounted() {
		// eslint-disable-next-line no-unused-vars
		this.initSlider();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

/* write SCSS here */

.slider {
	background-color: white;
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	justify-content: flex-start;
	align-items: flex-start;
	padding: 0;
	width: 100%;
	height: auto;

	@media (max-width: 1366px) {
		height: auto;
	}
}

.swiper-container {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;

	.swiper-wrapper {
		.swiper-slide {
			width: calc(100% - 100px) !important;
			padding: 50px;
			display: flex;
			flex-direction: column;
			flex-wrap: wrap;
			align-items: flex-start;
			min-height: 200px;

			.title {
				color: $signs-teal;
				margin-top: 50px;
				margin-bottom: 0;
				font-weight: normal;
				color: $signs-pink;
			}

			.text {
				color: $signs-teal;
				font-weight: normal;
				line-height: 2.25rem;
				margin-left: 1px;
				margin-bottom: 50px;
			}

			.the_button {
				@media (max-width: 1366px) {
					margin-bottom: 50px;
				}
			}
		}
	}
}

.swiper-pagination {
	color: $signs-teal;
	width: 50%;
	left: 0;
	text-align: left;

	.fraction__dash {
		width: 50px;
		height: 1px;
		background: $signs-teal;
		display: inline-block;
		margin: 5px;
	}
}

.swiper-pag-nag {
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	align-items: center;
	height: 40px;
	position: relative;
	width: calc(100% - 100px);
	bottom: 0;
	margin-top: 0;
	padding: 40px 50px;

	@media (max-width: 1366px) {
		display: none;
	}

	.swiper-nav {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		z-index: 10;
		position: relative;
		width: 100%;
		left: 0;

		.swiper-button-prev-testimonial,
		.swiper-button-next-testimonial {
			display: flex;
			margin-right: 10px;

			&:hover {
				cursor: pointer;

				svg {
					path {
						&:first-of-type {
							fill: $signs-pink;
						}

						&:last-of-type {
							fill: white;
						}
					}
				}
			}

			img {
				height: 40px;
			}

			svg {
				height: 40px;

				path {
					transition: 0.2s fill ease;
				}
			}
		}
	}
}
</style>





// WEBPACK FOOTER //
// resources/assets/scripts/vue/TextSlider.vue